﻿import { onEvent } from "./_dom.js";

const defaultSelector = "input[type=radio][data-toggle-target],input[type=checkbox][data-toggle-target]";

function clickHandler(_event, target) {
	const targetId = target.dataset.toggleTarget;
	document.getElementById(targetId)?.[target.checked ? "removeAttribute" : "setAttribute"]("hidden", "")
};


function init(context, selector = defaultSelector) {
	onEvent(document, defaultSelector, "click", clickHandler);
}

export { init };